<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" @click="setToday">
            Hoy
          </v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Día</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mes</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 días</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">

        <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :event-color="getEventColor"
        :event-text-color="getEventTextColor"
          :event-margin-bottom="3" :now="today" :type="type" @click:event="showEvent" @click:more="viewDay"
          @click:date="viewDay" @change="updateRange" :weekdays="[1, 2, 3, 4, 5, 6, 0]" locale="es"
          :short-weekdays="false"></v-calendar>

      


        <v-dialog v-model="selectedOpen" max-width="800px">
          <v-card color="grey lighten-4" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title v-html="selectedEvent.name" style="color: black;"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-form v-if="currentlyEditing !== selectedEvent.id" :style="{ color: 'black' }">

                <v-row>
                  <ul>
                    <li v-for="documento in documentos" :key="documento.id">
                      {{ documento.documentonombre }}
                    </li>
                  </ul>

               
                </v-row>

                    <div align="center" justify="center">
                            <div class="my-2">
                              <v-btn color="primary" @click="realizado(selectedEvent)">Realizado</v-btn>
                            </div>
                          </div>
              </v-form>

             
            </v-card-text>

            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-sheet>
    </v-col>
  </v-row>
</template>


<script>
// Asegúrate de tener 'vue-textarea-autosize' instalado si lo usas
// npm install vue-textarea-autosize
// import TextareaAutosize from 'vue-textarea-autosize';

import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";

export default {
  // components: {
  //   TextareaAutosize // Descomenta si estás usando el componente textarea-autosize
  // },
  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Día',
      '4day': '4 Días',
    },
    // Estas propiedades 'start' y 'end' se usarán para el v-model de los input de fecha en el modal
    // y se actualizarán con cadenas ISO en updateRange.
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [
      {
        id: 1,
        name: 'Evento de ejemplo',
        details: 'Descripción del evento',
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        color: '#1976D2',
      }
    ],
    name: null,
    details: null,
    color: '#1976D2',
    dialog: false,
    currentlyEditing: null,
    nextId: 2, // Para simular el ID autoincremental
    documentos: []
  }),
  computed: {
    title() {
      const { start, end } = this;
      if (!start || !end) return '';

      // Opciones para toLocaleString
      const options = { year: 'numeric', month: 'long', day: 'numeric' };

      // Creamos objetos Date a partir de las cadenas ISO para un formato correcto
      // Añadimos 'T00:00:00' para asegurar que las fechas se interpreten en UTC
      // y evitar posibles desviaciones por la zona horaria local.
      const startDateObj = new Date(start + 'T00:00:00');
      const endDateObj = new Date(end + 'T00:00:00');

      switch (this.type) {
        case 'month':
          // Para el mes, solo necesitamos el mes y el año
          return startDateObj.toLocaleString('es', { month: 'long', year: 'numeric' });
        case 'week':
        case '4day':
          // Para semana y 4 días, mostramos el rango completo
          return `${startDateObj.toLocaleString('es', options)} - ${endDateObj.toLocaleString('es', options)}`;
        case 'day':
          // Para el día, mostramos la fecha completa
          return startDateObj.toLocaleString('es', options);
      }
      return '';
    },
  },

  created() {

    this.listar();

  },


  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    updateEvent(ev) {
      const index = this.events.findIndex(e => e.id === ev.id);
      if (index !== -1) {
        // Asegúrate de copiar el evento para que Vue detecte el cambio reactivo
        this.events.splice(index, 1, { ...ev });
      }
      this.selectedOpen = false;
      this.currentlyEditing = null;
    },

    getEventTextColor(event) {
    return 'black'; // aquí forzas el texto a negro
  },

    listar11() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/eventos/listar/"
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.events = response.data.eventodetalle;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    realizado(documento) {

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
        me.$swal({
        icon: "warning",
        title: "Estas Seguro de Realizar El Evento",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/eventos/eventocolor/"+documento.id, {
             
            }, configuracion)
            .then(function (response) {
               me.listar();
              me.$swal("Guardado", "Se a Guardado con Exito", "success");
              me.selectedOpen=false
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });





      
        
    },


      listar() {
            // Variable para cargar los datos del api
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Manda llamar al listado e catalogos
            axios
                .get("api/eventos/listar", configuracion)
                .then(function (response) {
                   me.events = response.data.eventodetalle;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.data.code == 400) {
                        me.$swal("La Sesión a Expirado");
                        me.$store.dispatch("salir");
                    }
                });
        },

    listardocumentoevento(item) {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/eventos/listarexpediente/" + item.id + "/" + item.start
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.documentos = response.data.expedientedetalle;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    editEvent(id) {
      this.currentlyEditing = id;
    },
    deleteEvent(ev) {
      this.events = this.events.filter(e => e.id !== ev.id);
      this.selectedOpen = false;
    },
    addEvent() {
      if (this.name && this.start && this.end) {
        const newEvent = {
          id: this.nextId++,
          name: this.name,
          details: this.details,
          start: this.start, // Ya es una cadena ISO gracias al v-model type="date"
          end: this.end,     // Ya es una cadena ISO gracias al v-model type="date"
          color: this.color
        };
        this.events.push(newEvent);
        this.dialog = false;

        // Resetear los campos del formulario
        this.name = null;
        this.details = null;
        this.start = null;
        this.end = null;
        this.color = '#1976D2';
      } else {
        console.warn('Para agregar un evento, los campos de nombre, inicio y fin son obligatorios.');
        // Opcional: podrías mostrar una notificación al usuario aquí
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.listardocumentoevento(event);
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      // El v-calendar en el evento @change proporciona objetos con year, month, day.
      // Los convertimos a cadenas ISO para que el `computed` 'title' pueda usarlos fácilmente
      // y también para el v-model de los inputs de tipo 'date'.
      this.start = `${start.year}-${String(start.month).padStart(2, '0')}-${String(start.day).padStart(2, '0')}`;
      this.end = `${end.year}-${String(end.month).padStart(2, '0')}-${String(end.day).padStart(2, '0')}`;
    },
    // La función nth ya no es necesaria con el nuevo formato de título
    // nth(d) {
    //   return d > 3 && d < 21 ? 'th' : ['th', 'st', 'nd', 'rd'][d % 10] || 'th'
    // }
  }
}
</script>

<style scoped>


</style>